<template>
  <OldGuiFrame v-if="!showNewTimeReport">
  </OldGuiFrame>

  <v-container v-else fluid style="height: inherit;">
    <v-row style="background-color: white;">
      <v-col>
        <EmploymentSelect v-model="EmploymentId" clearable externaledit singleline>
        </EmploymentSelect>
      </v-col>
      <v-col>
        <!--
        <v-switch class="ma-0 pa-0" dense :label="groupBy ? 'Grouped' : 'Ungrouped'" :input-value="!!groupBy"
          @change="val => groupBy = val ? 'EmploymentTimeReportDate' : null" hide-details>
        </v-switch>
         -->
        <!--
        <DepartmentSelect v-model="departmentFilter" singleline multiple clearable externaledit singleline>
        </DepartmentSelect>
        -->
      </v-col>
      <v-col>
        <!--
        <ProjectSelect v-model="ProjectId" :label="$t('servicesystem.common_objects.project.project')" multiple singleline
          clearable externaledit>
        </ProjectSelect>
        -->
      </v-col>

    </v-row>
    <v-row class="mb-0">
      <TimeReportTable :height="contentHeight - 57" :reportFilter="reportFilter" :defaultColumns="columns"
        :groupBy="groupBy" :tableStorageKey="'TimeReportTable'">
      </TimeReportTable>
    </v-row>
  </v-container>
</template>


<script>
import EmploymentSelect from "@/components/Inputs/EntityDropdowns/EmploymentSelect2.vue";
//import DepartmentSelect from "@/components/Inputs/EntityDropdowns/DepartmentSelect2.vue";
//import ProjectSelect from "@/components/Inputs/EntityDropdowns/ProjectSelect2.vue";
import TimeReportTable from "../mypage/TimeReportTable2.vue";
import OldGuiFrame from "@/views/landingpages/OldGuiFrame.vue"

export default {
  name: "TimeReport",
  props: {},
  components: {
    //DepartmentSelect,
    //ProjectSelect,
    EmploymentSelect,
    TimeReportTable,
    OldGuiFrame
  },

  data() {
    return {
      ProjectId: null,
      departmentFilter: null,
      EmploymentId: null,

      groupBy: null,
      columns: {
        EmploymentTimeReportDate: {
          prop: 'EmploymentTimeReportDate', label: this.$t('servicesystem.common_objects.commonterms.date'), show: 'always', width: 90
        },
        ParentJobId: {
          prop: 'ParentJobId', label: this.$t('servicesystem.common_objects.order.order'), show: true, width: 90, minWidth: 80
        },
        CustomerId: {
          prop: 'CustomerId', label: this.$t('servicesystem.common_objects.customer.customer'), show: true, minWidth: 130
        },
        JobId: {
          prop: 'JobId', label: this.$t('servicesystem.common_objects.machine.machine'), show: true, minWidth: 180
        },
        ArticleNumber: {
          prop: 'ArticleNumber', label: this.$t('servicesystem.common_objects.article.article'), show: false, width: 100, minWidth: 100
        },
        StartDateTime: {
          prop: 'StartDateTime', label: this.$t('servicesystem.common_objects.commonterms.start'), show: false, width: 69, align: 'right'
        },
        ArticleCount: {
          prop: 'ArticleCount', label: this.$t('servicesystem.common_objects.time_report.hours'), show: false, width: 69, align: 'right'
        },
        Duration: {
          prop: 'Duration', label: this.$t('servicesystem.common_objects.time_report.duration'), show: true, width: 69, align: 'right'
        },
        StopDateTime: {
          prop: 'StopDateTime', label: this.$t('servicesystem.common_objects.commonterms.end'), show: false, width: 69, align: 'right'
        },
        ArticleDescription: {
          prop: 'ArticleDescription', label: this.$t('servicesystem.common_objects.order.description'), show: true, minWidth: 200
        },
        Actions: {
          prop: 'Actions', label: this.$t('servicesystem.common_objects.commonterms.actions'), show: 'always', minWidth: 45, width: 48, align: 'center', fixed: 'right'
        },
      },
    };
  },

  mounted() { },

  methods: {},

  computed: {
    showNewTimeReport() {
      return this.$store.state.GlobalSettings.ShowNewTimeReport;
    },

    reportFilter() {
      return {
        FromDate: this.startDate,
        ToDate: this.endDate,
        EmploymentId: this.EmploymentId,
      }
    },

    daterange() {
      return this.$store.state.triggerevents.reportDateRange;
    },
    startDate() {
      return this.daterange?.[0];
    },
    endDate() {
      return this.daterange?.[1];
    },

    contentHeight() {
      return this.$store.getters['navstore/ContentContainerHeight'];
    },

  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>